import { axios, Response } from '../index'

export default async function deleteReaction(
  reactionId: number
): Response<void> {
  return axios.delete(`/v1/reactions/${reactionId}`)
}
